import React from 'react';

import { WorkspacesType } from 'Dashboard/components/Onboarding/OnboardingWizard/types';
import { AvatarType } from 'Shared/constants/types';

import FakeSideNavigation from './FakeSideNavigation/FakeSideNavigation';
import FakeWorkspaceContent from './FakeWorkspaceContent/FakeWorkspaceContent';
import './FakeWPApp.scss';

type Props = {
  workspaces: WorkspacesType;
  currentUser: {
    fullName: string;
    avatar: AvatarType;
  };
};

function FakeWPApp({ workspaces, currentUser }: Props) {
  return (
    <div className="fake-wp d-flex w-100 flex-column flex-md-row">
      <FakeSideNavigation workspaces={workspaces} currentUser={currentUser} />
      <FakeWorkspaceContent currentUser={currentUser} workspace={workspaces[0]} />
    </div>
  );
}

export default FakeWPApp;
